import { render, staticRenderFns } from "./OfertasList.vue?vue&type=template&id=0b789a02"
import script from "./OfertasList.vue?vue&type=script&lang=js"
export * from "./OfertasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports